import { RxCollection } from 'rxdb';
import { LocalCredentialsModel, TableInfoModel, WorkspaceModel } from '../models';

export interface CentralDatabaseDbContext {
	workspaces: RxCollection<WorkspaceModel>;
	tableinfos: RxCollection<TableInfoModel>;
	localcredentials: RxCollection<LocalCredentialsModel>;
}
